<template>
  <div class="edit-parametro">
    <h1>Editar Parámetro</h1>
    
    <div class="alert alert-info" v-if="loading">Cargando parámetro...</div>
    <div class="alert alert-danger" v-if="error">{{ error }}</div>
    
    <div class="card p-4 bg-light" v-if="!loading && !error">
      <form @submit.prevent="submitForm" v-if="!loading && !error">
        <div class="mb-3">
          <label for="parametroClave" class="form-label">Clave</label>
          <input 
            type="text" 
            class="form-control" 
            id="parametroClave" 
            v-model="parametro.ParametroClave" 
            disabled
          >
        </div>
        <div class="mb-3">
          <label for="valor" class="form-label">Valor</label>
          <input 
            type="text" 
            class="form-control" 
            id="valor" 
            :value="parametro.Valor"
            @input="updateField('Valor', $event.target.value)"
          >
        </div>
        <div class="mb-3">
          <label for="descripcion" class="form-label">Descripciu00f3n</label>
          <textarea 
            class="form-control" 
            id="descripcion" 
            rows="3" 
            :value="parametro.Descripcion"
            @input="updateField('Descripcion', $event.target.value)"
          ></textarea>
        </div>
        <div class="d-flex gap-2">
          <button type="submit" class="btn btn-primary" :disabled="saving">
            {{ saving ? 'Guardando...' : 'Guardar Cambios' }}
          </button>
          <button type="button" class="btn btn-secondary" @click="goBack">
            Cancelar
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { useAccessControl } from '@/composables/useAccessControl'
import EditParametroViewController from '../controllers/EditParametroViewCtrl.js';

export default {
  name: 'EditParametroView',
  components: {
  },
  props: ['id'],
  setup() {
    const { requiresAuth, requiresMenuPermission } = useAccessControl({
      requiresAuth: true,
      requiresMenuPermission: true
    })

    return {
      requiresAuth,
      requiresMenuPermission
    }
  },
  data() {
    return {
      controller: new EditParametroViewController()
    }
  },
  computed: {
    parametro() {
      return this.controller.getParametro();
    },
    loading() {
      return this.controller.isLoading();
    },
    saving() {
      return this.controller.isSaving();
    },
    error() {
      return this.controller.getCurrentError();
    }
  },
  created() {
    const parametroClave = this.$route.params.id;
    this.controller.initialize(parametroClave);
  },
  methods: {
    async submitForm() {
      if (!this.controller.validateForm()) {
        this.$alert.error('Por favor, complete todos los campos requeridos.');
        return;
      }

      try {
        const response = await this.controller.saveParametro();
        this.$mgkResponse.handleResponse(response, 'Parámetro actualizado con éxito.', 'Error al actualizar el parámetro.');
        if (response.data.Number > 0) {
          this.$router.push('/parametros');
        }
      } catch (error) {
        this.$alert.error('Error al actualizar el parámetro. Por favor, intente de nuevo.');
      }
    },
    goBack() {
      this.$router.push('/parametros');
    },
    updateField(field, value) {
      this.controller.updateField(field, value);
    }
  }
}
</script>

<style scoped>
.edit-parametro {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}
</style>
